/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

import { Spinner } from 'sarsaparilla';

interface LoadingWrapperProps {
    loading: boolean;
    size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
    className?: string;
    children: React.ReactNode;
}

export default function LoadingWrapper({
    className = '',
    loading = false,
    size,
    children,
}: LoadingWrapperProps) {
    if (loading) {
        return (
            <div
                className={`${className} loading-wrapper is-not-loaded rec-lottery-loading`}
            >
                <Spinner size={size} />
            </div>
        );
    }

    return <div className={`${className} loading-wrapper is-loaded`}>{children}</div>;
}
